import request from '@/utils/request'

// 示例接口
export function getExampleData(params) {
  return request({
    url: '/api/example',
    method: 'get',
    params
  })
}

// 其他接口可以按同样方式添加
export function postExampleData(data) {
  return request({
    url: '/api/example',
    method: 'post',
    data
  })
}

export const Channel = (channelKey, data = {}) => request({
  url: `/client/article/channel/${channelKey}`,
  method: 'get',
  params: {
    CategoryId: data.CategoryId,
    PageIndex: data.pageNo,
    PageSize: data.pageSize || 100,
    SiteId: 1
  }
})

export const Show = key => request({
  url: `/client/article/show/${key}`,
  method: 'get',
  params: {
    SiteId: 1
  }
})

// 2. 公司介绍类的channelKey为content
// content下有四个category分别为
// categoryId=4  首纳简介
// categoryId=5 联系我们
// categoryId=6  荣誉介绍
// categoryId=7 合作伙伴，合作伙伴为多个，可滚动，图片暂时使用封面图字段imgUrl
// export const FetchIntro = () => Channel('content', { CategoryId: 4 })
export const FetchIntro = () => Show('introduction')

// 联系我们
export const FetchContactUs = () => Show('contact')

// 荣誉介绍 honorary
export const FetchHonor = () => Show('honorary') // Channel('content', { CategoryId: 6 })

// 合作伙伴
export const FetchPartner = () => Channel('content', { CategoryId: 7, pageNo: 1, pageSize: 99 })

// 新闻资讯类的channelKey为news
// news下有两个category分别为
// categoryId=8 banner 图片暂时使用封面图字段imgUrl
// categoryId=9 新闻

// 首页banner
export const FetchBanner = () => Channel('news', { CategoryId: 8 })

//首页百科
export const FetchBaike = () => Channel('news', { CategoryId: 3 })

// 新闻
export const FetchNews = ({ pageNo, pageSize }) => Channel('news', { pageNo, pageSize })

// 新闻详情
export const FetchNewsDetail = id => Show(id)

// 新闻 上一条下一条
export const FetchNewsNext = id => request({
  url: `/client/article/next/${id}`,
  method: 'get',
  params: {
    CategoryId: 9,
    SiteId: 1
  }
})

// 产品信息类的channelKey为productInfo (暂时未完成)
// productInfo下有四个category分别为
// categoryId=10  漆面保护膜
// categoryId=11 汽车太阳膜
// categoryId=12  车身改色膜
// categoryId=13 防火膜，

// 查询产品列表
export const FetchProductList = () => request({
  url: `/client/article/category/channel/productInfo`,
  method: 'get',
  params: {
    SiteId: 1
  }
})

// 查询产品 漆面保护膜
// categoryId=10  漆面保护膜
// categoryId=11 汽车太阳膜
// categoryId=12  车身改色膜
// categoryId=13 防火膜，
export const FetchProductBh = (CategoryId) => Channel('productInfo', { CategoryId })

export const FetchProductCategory = (CategoryId) => Channel('6', { CategoryId })

// /client/article/channel/6?CategoryId=21&SiteId=1
export const FetchProductDetail = (CategoryId) => Show(CategoryId)

// xx
export const FetchQuoteCategory = () => request({
  url: `/client/shop/category`,
  method: 'get',
  params: {
    SiteId: 1,
  }
})
export const FetchPriceFilter = (category,series) => request({
  url: `/CarFilm/price/filter`,
  method: 'get',
  params: {
    category,
    series,
  }
})

// 查询系列，型号及前后档系列接口
export const FetchQuoteDetail = (parent_id, SkuCategory) => request({
  url: `/client/shop/sku`,
  method: 'get',
  params: {
    SiteId: 1,
    level_type: 'sku',
    parent_id,
    SkuCategory
  }
})

// 报价
export const FetchQuoteList = ({category, series, model, carType}) => request({
  url: `/CarFilm/Product/search`,
  method: 'get',
  params: {
    SiteId: 1,
    category,
    series,
    model,
    carType
  }
})

// 查询膜类型
export const FetchFilmType = () => request({
  url: `/car/user/film/type`,
  method: 'get',
  params: {}
})

// 查询质保详情
export const FetchRecord = (params) => request({
  url: `/car/user/qa/record`,
  method: 'get',
  params: params
})

export const FetchDomain = (params) => request({
  url: `/client/site/domain`,
  method: 'get',
  params: params
})